<div width="100%" height="100%" class="wiz-component-container" [ngClass]="{'disabled-class': wizDisabled}">

  <div class="wiz-component-label" width="100%" *ngIf="wizShowLabel">
    <wiz-label  id="label" #innerLabel [wizLabel]="wizLabel" [wizTextBehavior]="'truncate'"
    [ngClass]="{'error-class': hasErrors}"></wiz-label><!-- label -->
    <span #innerAsterisk *ngIf="wizMandatory" class='mandatory-class'>*</span><!-- asterisque -->
  </div>

  <!-- zone de saisie -->
  <div id="inzone" width="100%" class="wiz-component-field textarea-content innerfocus-class" [ngClass]="{'error-class': hasErrors}" >
    <textarea #innerInput
            type="text" width="100%" height="100%"
            [maxlength]="wizMaxChars"
            [placeholder]="translatedPlaceholder"
            [ngModel]="getWizValue()"
            [disabled]="wizDisabled"
            class="wiz-input"
            (ngModelChange)="onChange($event)"
            (blur)="onBlur($event)"
            (focus)="onFocus($event)"
            autocomplete="off"
            [tabIndex]="wizTabIndex"></textarea>

                <!-- bouton de droite -->
    <!-- wizNotFocusable utilisé pour éviter la perte de focus au niveau du dom  -->
    <!-- TODO utiliser un wiz-icon -->
    <mat-icon #innerRightIcon style="align-self: flex-start;" wizNotFocusable *ngIf="wizRightIcon" (click)="wizOnRightIconClicked()" 
    class="innerIcon textarea-in">
      <wiz-icon class="smallMe">{{wizRightIcon}}</wiz-icon>
    <!-- {{wizRightIcon}} -->
    </mat-icon>

    </div>

  <div class="wiz-component-hint" width="100%">
    <!-- le hint -->
    <wiz-label #innerhint class="hint-class" *ngIf="wizHint" [wizLabel]="wizHint"></wiz-label>
    <!-- l'affichage de l'erreur -->
    <ng-container #errorContainer id="error"></ng-container>
  </div>
</div>

